import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';

import {Speaker} from '../models/speaker';
import {SpeakerService} from '../speaker.service';

@Component({
  selector : 'results',
  templateUrl : './results.component.html',
  styleUrls : [ './results.component.css' ],
  encapsulation: ViewEncapsulation.None
})
export class ResultsComponent implements OnInit {

  @Input() speakers: Speaker[];
  @Output() onRowSelect = new EventEmitter();
  sorttable: any;

  constructor(private speakerService: SpeakerService) {}

  ngOnInit() {
    // this.sorttable.makeSortable(document.getElementById("table"));
    this.speakerService.speakersChange.subscribe(speakers => {
      this.speakers = speakers;
    });
  }

  rowClick(event) { this.onRowSelect.emit({src : "SPEAKER", event : event}); }
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/results/results.component.ts